import { Lightning, Router } from '@lightningjs/sdk';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL, ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';

export class AbstractPopup extends Lightning.Component {
  _handleBack() {
    this.signal(this._getCloseActionSignal());

    return true;
  }

  _getCloseActionSignal() {
    if (this._checkHistoryAvailable()) {
      return ROUTE_BACK_SIGNAL;
    }

    if (this._exitAppOnClose) {
      return EXIT_APP_SIGNAL;
    }

    return HIDE_POPUP_SIGNAL;
  }

  _checkHistoryAvailable() {
    return this._routeBackOnClose && Router.getHistory().length > 0;
  }

  get routeBackOnClose() {
    return this._routeBackOnClose;
  }

  set routeBackOnClose(value) {
    this._routeBackOnClose = value;
  }

  set exitAppOnClose(value) {
    this._exitAppOnClose = value;
  }
}
